<div
  class="loader"
  [ngClass]="['loader--' + variant(), 'loader--' + size()]"
  role="status"
  aria-live="polite"
>
  <div class="loader__content">
    <svg class="loader__spinner" viewBox="0 0 50 50">
      <circle
        class="loader__spinner-track"
        cx="25" cy="25" r="20"
        fill="none" stroke-width="4"
      ></circle>
      <circle
        class="loader__spinner-arc"
        cx="25" cy="25" r="20"
        fill="none" stroke-width="4"
      ></circle>
    </svg>

    @if (message()) {
      <span class="loader__text">{{ message() }}</span>
    }
  </div>
</div>